// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable design-system/ensure-design-token-usage */
.T6Am4feFgenohb {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 90dvw;
  height: 90dvh;
  background: #000000;
}
.ijzVNGGEvAWAOA > div {
  margin: var(--ds-space-0, 0);
}
.ijzVNGGEvAWAOA {
  scrollbar-gutter: initial;
}
.P_wMHdN72_tj7P {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 100%;
  height: 100%;
}
.hCejJwJ3Qr0cFK {
  position: absolute;
  top: var(--ds-space-200, 16px);
  right: var(--ds-space-200, 16px);
  border-radius: var(--ds-border-radius-400, 16px);
  background: #0c66e4;
  color: #ffffff;
}
.hCejJwJ3Qr0cFK:hover {
  background: #0055cc;
  color: #ffffff;
}
.hCejJwJ3Qr0cFK:active {
  background: #09326c;
  color: #ffffff;
}
`, ""]);
// Exports
export var overlay = `T6Am4feFgenohb`;
export var overlayOverrides = `ijzVNGGEvAWAOA`;
export var videoIframe = `P_wMHdN72_tj7P`;
export var closeButton = `hCejJwJ3Qr0cFK`;
export default ___CSS_LOADER_EXPORT___;
